export default __webpack_public_path__ + "static/unifiedpost_logo-b2047395ef860ffc5865963a448a9f17.svg";